/** cache-and-network resolves `.toPromise()` before the network result lands. */
export const NETWORK_ONLY = { requestPolicy: 'network-only' as const }
